<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <el-row :gutter="10">
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('rfqid')"
          prop="rfqid"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.rfqid"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-part-number
            :model="form.partID"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('part-sn')"
          prop="partSN"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="autoSaveField('partSN')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('stock')"
          prop="stockID"
          class="material-style"
        >
          <select-stock
            :model.sync="form.stockID"
            @on-change="autoSaveField('stockID')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('release')"
          prop="releaseID"
          class="material-style"
        >
          <select-response
            :model.sync="form.releaseID"
            @on-change="autoSaveField('releaseID')"
            :data="dataSourceRelease.records"
            :isLoading="dataSourceRelease.loading"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style">
          <select-response
            :model.sync="form.conditionID"
            @update:model="autoSaveField('conditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :xs="6" :md="6" :lg="4">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="autoSaveField('qty')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="4">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="autoSaveField('price')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="4">
        <el-form-item
          :label="L10n('supply-date')"
          prop="supplyDate"
          class="material-style"
        >
          <el-input
            :value="form.supplyDate"
            @input="form.supplyDate = valueTrimLeft($event)"
            @change="autoSaveField('supplyDate')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="3">
        <el-form-item
          :label="L10n('currency')"
          prop="currencyID"
          class="material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="autoSaveField('currencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="5">
        <el-form-item
          :label="L10n('core-due-date')"
          prop="coreDueDate"
          class="material-style"
        >
          <date-picker
            v-model="form.coreDueDate"
            @change="autoSaveField('coreDueDate')"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :xs="12" :md="12" :lg="4">
        <el-form-item
          :label="L10n('exchange-core-received')"
          prop="exchangeCoreReceived"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.exchangeCoreReceived"
            @change="autoSaveField('exchangeCoreReceived')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="4">
        <el-form-item
          :label="L10n('exchange-core-value')"
          prop="exchangeCoreValue"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.exchangeCoreValue"
            @input="form.exchangeCoreValue = valueNumber($event)"
            @change="autoSaveField('exchangeCoreValue')"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="6" :md="6" :lg="4">
        <el-form-item
          :label="L10n('exchange-condition')"
          prop="exchangeConditionID"
          class="material-style">
          <select-response
            :model.sync="form.exchangeConditionID"
            @update:model="autoSaveField('exchangeConditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="3">
        <el-form-item
          :label="L10n('exchange-core-value-currency')"
          prop="exchangeCoreValueCurrencyID"
          class="material-style"
        >
          <select-response
            :model.sync="form.exchangeCoreValueCurrencyID"
            @update:model="autoSaveField('exchangeCoreValueCurrencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="5">
        <el-form-item
          :label="L10n('quote-date')"
          prop="quoteDate"
          class="material-style"
        >
          <date-picker
            v-model="form.quoteDate"
            @change="autoSaveField('quoteDate')"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('traceability-company')"
          prop="traceabilityCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.traceabilityCompanyID"
            @on-change="autoSaveField('traceabilityCompanyID')"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('tag-info-company')"
          prop="tagInfoCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.tagInfoCompanyID"
            @update:model="autoSaveField('tagInfoCompanyID')"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="8">
        <el-form-item
          :label="L10n('tag-date')"
          prop="tagDate"
          class="material-style"
        >
          <date-picker
            v-model="form.tagDate"
            @change="autoSaveField('tagDate')"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="24" :lg="24">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style">
          <el-input
            type="textarea"
            :rows="3"
            :value="form.remarks"
            @input="form.remarks = valueTrimLeft($event)"
            @change="autoSaveField('remarks')"/>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="12" :lg="8" :xl="3">
        <el-form-item
          :label="L10n('is-been-chosen')"
          prop="chosen"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.chosen"
            @change="autoSaveField('chosen')">
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="12" :lg="8" :xl="3">
        <el-form-item
          :label="L10n('send-mail')"
          prop="sendMail"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.sendMail"
            @change="autoSaveField('sendMail')">
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateSupplier } from '@/mixins/companies'

export default {
  name: 'FormContacts',
  mixins: [Form, mixUpdateSupplier],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-stock': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectStock/Index.vue')
  },
  computed: {
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title&orderBy=title')
    }
  },
  methods: {
  }
}
</script>
